
// endpoint name: '{Controller}_{ControllerMethod}'

// Account
export const Accounts_Get = "Accounts/{accountId}";
export const Accounts_InsertAccount = "Accounts"; // POST
export const Accounts_DeleteAccount = "Accounts/{accountId}"; // DELETE
export const Accounts_InsertRestriction = "Accounts/{accountId}/Restrictions"; // POST
export const Accounts_UpdateRestriction = "Accounts/Restrictions/{accountRestrictionId}"; // PUT
export const Accounts_DeleteRestriction = "Accounts/Restrictions/{accountRestrictionId}"; // DELETE
export const Accounts_InsertRole = "Accounts/{accountId}/Roles"; // POST
export const Accounts_DeleteRole = "Accounts/Roles/{accountRoleId}"; // DELETE
export const Accounts_GenerateAccesses = "Accounts/GenerateAccesses";
export const Accounts_CountToGenerate = "Accounts/CountToGenerate";
export const Accounts_InsertCustomerLogin = "Accounts/InsertCustomerLogin"; // POST

// ARES
export const Ares_AresBasic = "Ares/{companyRegistrationNumber}/Basic";

// Billings
export const Billings_Get = "Billings/{billingId}";
export const Billings_BillingDetails = "Billings/{billingId}/BillingDetails";
export const Billings_DownloadDocument = "Billings/{billingId}/Download/{downloadType}"; // generic endpoint; downloadType} can contain value from InvoiceDownloadDetailType enum

// Customer
export const Customer_GetSimplified = "Customers";
export const Customer_Get = "Customers/{customerId}";
export const Customer_Contacts = "Customers/{customerId}/Contacts";
export const Customer_Contracts = "Customers/{customerId}/Contracts";
export const Customer_FuelingContracts = "Customers/{customerId}/FuelingContracts";
export const Customer_Payments = "Customers/{customerId}/Payments";
export const Customer_Payments_AmountLimits = "Customers/{customerId}/Payments/AmountLimits";
export const Customer_Invoices = "Customers/{customerId}/Invoices";
export const Customer_InvoicesFilterDefaults = "Customers/{customerId}/Invoices/FilterDefaults";
export const Customer_Invoices_AmountLimits = "Customers/{customerId}/Invoices/AmountLimits";
export const Customer_Requirements = "Customers/{customerId}/Requirements";
export const Customer_SummaryInfo = "Customers/{customerId}/SummaryInfo";
export const Customer_ContractDropdown = "Customers/{customerId}/Contracts/Dropdown";
export const Customer_PaymentMethods = "Customers/{customerId}/PaymentMethods";
export const Customer_Sipos = "Customers/{customerId}/Sipos";
export const Customer_BankAccounts = "Customers/{customerId}/BankAccounts";
export const Customer_ContractualAccounts = "Customers/{customerId}/ContractualAccounts";
export const Customer_Accounts = "Customers/{customerId}/Accounts";
export const Customer_ContactPerson = "Customers/{customerId}/ContactPerson";
export const Customer_MarketingConsents = "Customers/{customerId}/MarketingConsents";
export const Customer_Supplier = "Customers/{customerId}/Supplier";
export const Customer_InsertMarketingConsents = "Customers/{customerId}/MarketingConsents"; // POST
export const Customer_EconomicalTariff = "Customers/{customerId}/EconomicalTariff";
export const Customer_ConsumptionHistory = "Customers/{customerId}/ConsumptionHistory";
export const Customer_ConsumptionHistorylExport = "Customers/{customerId}/ConsumptionHistory/Export";
export const Customer_PersonsInRelationship = "Customers/{customerId}/PersonsInRelationship";

// Consumption
export const Consumption_ConsumptionRealDetail = "Consumption/RealDetail";
export const Consumption_ConsumptionRealDetailExportEvn = "Consumption/RealDetail/Export/EVN";
export const Consumption_ConsumptionRealDetailExportPvo = "Consumption/RealDetail/Export/PVO";
export const Consumption_ConsumptionRealDetailExportEnnB = "Consumption/RealDetail/Export/ENN/B";
export const Consumption_ConsumptionHeat = "Consumption/Heat";

// Contract
export const Contract_Get = "Contract/{contractId}";
export const Contract_EnergyType = "Contract/{contractId}/{energyType}"; // generic endpoint; energyType can contain value from ContractType enum
export const Contract_SelfReadings = "Contract/{contractId}/SelfReadings";
export const Contract_Invoices = "Contract/{contractId}/Invoices";
export const Contract_Consumption = "Contract/{contractId}/Consumption";
export const Contract_CapacityElectricity = "Contract/{contractId}/CapacityElectricity/{year}";
export const Contract_CapacityGas = "Contract/{contractId}/CapacityGas/{year}";
export const Contract_CapacityGasDraft = "Contract/{contractId}/CapacityGas/{year}/Draft";
export const Contract_ChangePlaceOfDeliveryName = "Contract/{contractId}/PlaceOfDelivery"; // POST
export const Contract_Readings_LastKnown = "Contract/{contractId}/Readings/LastKnown";
export const Contract_InvoiceSimulations = "Contract/{contractId}/InvoiceSimulations";
export const Contract_Prices = "Contract/{contractId}/Prices";
export const Contract_Documents = "Contract/{contractId}/Documents";
export const Contract_SpotProduct = "Contract/{contractId}/SpotProduct";
export const Contract_FuelingCards = "Contract/{contractId}/FuelingCards";
export const Contract_ContractHeatConsumptionTypes = "Contract/{contractId}/HeatConsumptionTypes";
export const Contract_ContractHeatConsumptionMessages = "Contract/{contractId}/HeatConsumptionMessages";

// Contracting
export const Contracting_UpdateContracting = "Contracting"; // POST
export const Contracting_FinishContracting = "Contracting/Finish"; // POST
export const Contracting_AddContracting = "Contracting/Add"; // POST
export const Contracting_Get = "Contracting/{contractingId}";
export const Contracting_Configuration = "Contracting/Configuration"
export const Contracting_List = "Contracting/List"

// ContractualAccounts
export const ContractualAccounts_Get = "ContractualAccounts/{contractualAccountId}";
export const ContractualAccounts_ContactPersons = "ContractualAccounts/{contractualAccountId}/ContactPersons";
export const ContractualAccounts_PropertyManager = "ContractualAccounts/{contractualAccountId}/PropertyManager";

// Dashboard
export const Dashboard_ContractsCount = "Dashboard/Customers/{customerId}/ContractsCount";
export const Dashboard_LastInvoices = "Dashboard/Customers/{customerId}/LastInvoices";
export const Dashboard_Requirements = "Dashboard/Customers/{customerId}/Requirements";
export const Dashboard_ExpectedPayments = "Dashboard/Customers/{customerId}/ExpectedPayments";
export const Dashboard_Payments = "Dashboard/Customers/{customerId}/Payments";
export const Dashboard_Consumption = "Dashboard/Customers/{customerId}/Consumption";
export const Dashboard_Alerts = "Dashboard/Customers/{customerId}/Alerts";
export const Dashboard_Messages = "Dashboard/Customers/{customerId}/Messages";

// Document
export const Document_DocumentDownload = "Document/{documentId}";

// Enums
export const Enums_DocumentType = "Enums/DocumentType";
export const Enums_RequirementType = "Enums/{customerId}/RequirementType";
export const Enums_Addresses = "Enums/Addresses/Find";
export const Enums_DistributionRateType = "Enums/DistributionRates";
export const Enums_PaymentMethodType = "Enums/PaymentMethodTypes";
export const Enums_BankType = "Enums/Banks";
export const Enums_MessageCategory = "Enums/MessageCategory";
export const Enums_CapacityGasType = "Enums/CapacityGas/Type";

// Fueling
export const Fueling_FuelingTransactionsExport = "Fueling/Transactions/Export";
export const Fueling_FuelingHistory = "Fueling/History";
export const Fueling_FuelingSummary= "Fueling/Transactions/Summary/{year}";
export const Fueling_FuelingSummaryExport= "Fueling/Transactions/Summary/{year}/Export";
export const Fueling_FuelingSummaryDetail = "Fueling/Transactions/Summary/{year}/{month}";
export const Fueling_FuelingContractsDuration = "Fueling/ContractsDuration";

// Invoices
export const Invoices_Get = "Invoices/{invoiceId}";
export const Invoices_AdvanceDetail = "Invoices/{invoiceId}/AdvanceDetail";
export const Invoices_PaidAdvance = "Invoices/{invoiceId}/PaidAdvance";
export const Invoices_InvoiceLineCalculation = "Invoices/{invoiceId}/InvoiceLineCalculation";
export const Invoices_InvoiceLineProduct = "Invoices/{invoiceId}/InvoiceLineProduct";
export const Invoices_Payments = "Invoices/{invoiceId}/Payments";
export const Invoices_QrPaymentGet = "Invoices/{invoiceId}/QrPayment";
export const Invoices_DownloadDetailTypes = "Invoices/{invoiceId}/DownloadDetailTypes";

// InvoiceSimulations
export const InvoiceSimulations = "InvoiceSimulations";
export const InvoiceSimulations_Calculate = "InvoiceSimulations/Calculate";

// ParentCompany
export const ParentCompany_GetParentCompany = "ParentCompany";

// Payments
export const Payments_Get = "Payments/{paymentId}";
export const Payments_FinancialSettlement = "Payments/{paymentId}/FinancialSettlement";

// PlaceOfDelivery
export const PlaceOfDelivery_Consumption = "PlaceOfDelivery/{placeOfDeliveryId}/Consumption/{year}";
export const PlaceOfDelivery_ConsumptionExport = "PlaceOfDelivery/{placeOfDeliveryId}/Consumption/{year}/Export";
export const PlaceOfDelivery_ContractsDuration = "PlaceOfDelivery/ContractsDuration";

// Reactions
export const Reactions_Get = "Reactions/{reactionId}";

// Registration
export const Registration_RegisterCustomerAccount = "Registration/CustomerAccount"; // POST
export const Registration_SendCustomerNotFoundInfo = "Registration/CustomerAccount/CustomerNotFound"; // POST

// Exports
export const Exports_GetDefinitions = "Exports/Definitions";
export const Exports_GetDefinitionDetial = "Exports/Definitions/{exportDefinitionId}";
export const Exports_Export = "Exports/{exportDefinitionId}";

// Requirements
export const Requirements_Get = "Requirements/{requirementId}";
export const Requirements_Documents = "Requirements/{requirementId}/Documents";
export const Requirements_Reactions = "Requirements/{requirementId}/Reactions";
export const Requirements_RequirementDocumentsType = "Requirements/{requirementId}/RequirementDocumentsType";
export const Requirements_SelfReadingContracts = "Requirements/SelfReading/Contracts";
export const Requirements_SelfReadingType = "Requirements/SelfReading/Type";
export const Requirements_SelfReadingPresetDateRoles = "Requirements/SelfReading/PresetDateRoles";
export const Requirements_SelfReadingMeter = "Requirements/SelfReading/Meter";
export const Requirements_ComplaintType = "Requirements/Complaints/Type";
export const Requirements_AdvanceChangeGetParams = "Requirements/AdvanceChange/GetParams";
export const Requirements_AdvanceChangeCanReduce = "Requirements/AdvanceChange/CanReduce";
export const Requirements_SelfReadingValidate = "Requirements/SelfReading/Validate"; // POST
export const Requirements_ECommunicationContractualAccount = "Requirements/eCommunication/ContractualAccount";
export const Requirements_InsertDocument = "Requirements/{requirementId}/Document"; // POST
export const Requirements_InsertReaction = "Requirements/{requirementId}/Reaction"; // POST
export const Requirements_InsertRequirement = "Requirements"; // POST
export const Requirements_EmailVerification = "Requirements/EmailVerification"; // POST
export const Requirements_MobilePhoneVerification = "Requirements/{requirementId}/MobilePhone/Verification"; // POST
export const Requirements_ReservedCapacityGasTimeInterval = "Requirements/ReservedCapacity/Gas/TimeInterval"; 
export const Requirements_EmailIsCorrespondence = "Requirements/Email/IsCorrespondence";

// Resources
export const Resources_DownloadResource = "Resources/Download";

// SelReading
export const SelReading_GetSelfReading = "SelfReading/{selfReadingId}";

// Tooltips
export const Tooltips_DistributionRate = "Tooltips/DistributionRate";
export const Tooltips_RequirementType = "Tooltips/RequirementType";

// Messages
export const Messages_Get = "Messages/{messageId}";
export const Messages_UpdateStatus = "Messages/{messageId}/UpdateStatus";

// UserInterfaceLog
export const UserInterfaceLog_Log = "UserInterfaceLog/Log";

// Users (admin)
export const Users_GetSimplified = "Users"